var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#ED2B30",
    fillOpacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 33.0002C27.4036 33.0002 33 27.4038 33 20.5002C33 13.5967 27.4036 8.00024 20.5 8.00024C13.5964 8.00024 8 13.5967 8 20.5002C8 27.4038 13.5964 33.0002 20.5 33.0002Z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6328 19.704L25.6849 15.0571C26.2442 14.855 26.7328 15.1936 26.5515 16.0394L26.5526 16.0384L24.5005 25.7061C24.3484 26.3915 23.9411 26.5582 23.3713 26.2352L20.2463 23.9321L18.739 25.3842C18.5724 25.5509 18.4317 25.6915 18.1088 25.6915L18.3307 22.5113L24.1224 17.279C24.3745 17.0571 24.0661 16.9321 23.7338 17.153L16.5765 21.6592L13.4911 20.6967C12.8213 20.4842 12.8067 20.0269 13.6328 19.704Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(8 8.00024)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.e8f408530d125f8b4fdbc1ff9d1f44f7.svg";
export { ForwardRef as ReactComponent };